// src/pages/WorkerLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../firebase";
import axios from "axios";
import { FcGoogle } from "react-icons/fc";
import bynLogo from "./byn-logo.jpeg";

const API_WRK =
  process.env.REACT_APP_API_WRK ||
  "https://api.bookyourneed.com/api/worker";

const WorkerLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");


  const handleRedirect = (worker) => {
    if (worker.status === "pending" || worker.status === "approved") {
      navigate("/dashboard");
    } else if (!worker.name) {
      navigate("/legal-name");
    } else if (!worker.phone) {
      navigate("/verify-phone");
    } else if (!worker.address) {
      navigate("/set-address");
    } else {
      navigate("/review-profile");
    }
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!email || !password) {
      setMessage("Email and password required.");
      return;
    }
    

    try {
      const res = await axios.post(`${API_WRK}/login`, { email, password });
      const worker = res.data;

      localStorage.setItem("workerId", worker._id);
      localStorage.setItem("workerToken", worker.token);
      localStorage.setItem("workerStatus", worker.status);
      localStorage.setItem("userEmail", email);

      handleRedirect(worker);
    } catch (err) {
      setMessage(err.response?.data?.message || "Login failed.");
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const res = await axios.post(`${API_WRK}/google-login`, {
        email: user.email,
        googleId: user.uid,
      });

      const worker = res.data;

      localStorage.setItem("workerId", worker._id);
      localStorage.setItem("workerToken", worker.token);
      localStorage.setItem("workerStatus", worker.status);
      localStorage.setItem("userEmail", user.email);

      handleRedirect(worker);
    } catch {
      setMessage("Google Sign-In failed.");
    }
  };

  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-md mx-auto space-y-6">

        {/* 🔥 TOP LOGO (same as customer) */}
        <div className="flex justify-center">
          <img
            src={bynLogo}
            alt="Book Your Need"
            className="w-44 h-44 object-contain"
          />
        </div>

        <form onSubmit={handleEmailLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 focus:ring-2 focus:ring-indigo-500"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 focus:ring-2 focus:ring-indigo-500"
          />

          <div className="text-right text-sm">
            <button
              type="button"
              onClick={() => navigate("/worker-forgot-password")}
              className="text-indigo-600 hover:underline"
            >
              Forgot password?
            </button>
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-full text-white font-semibold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:opacity-90 transition"
          >
            Log In
          </button>
        </form>

        <button
          onClick={handleGoogleLogin}
          className="w-full py-3 flex items-center justify-center gap-3 rounded-full border border-gray-200 bg-white text-gray-700 font-medium"
        >
          <FcGoogle size={20} />
          Continue with Google
        </button>

        <p className="text-sm text-gray-500 text-center">
          Don’t have an account?{" "}
          <button
            onClick={() => navigate("/worker-signup")}
            className="text-indigo-600 font-semibold hover:underline"
          >
            Sign up
          </button>
        </p>

        {message && (
          <p className="text-sm text-red-500 text-center">{message}</p>
        )}
      </div>
    </div>
  );
};

export default WorkerLogin;
